import * as Image from "shared/images";

export default Image;
